// Components
import PageLayer from "@Layouts/views/PageLayer";

import { ReactComponent as CommissionSupportIcon } from "@/assets/icons/header/ellipsis/CommissionSupportIcon.svg";

import { Wrapper } from "@/Washouts/views/Layers/SupportRequests/Wrapper";
import { SnackbarProvider } from "notistack";
import { SnackbarsCustomStyle, AUTO_HIDE_DURATION, MAX_SNACK } from "@Layouts/components/Snackbars";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import DoneIcon from "@mui/icons-material/Done";

export const SupportRequests = () => {
	return (
		<PageLayer title="Support Requests" icon={<CommissionSupportIcon className="text-medium-pink" />}>
			<SnackbarProvider
				maxSnack={MAX_SNACK}
				anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
				autoHideDuration={AUTO_HIDE_DURATION}
				iconVariant={{ 
					error: <ErrorOutlineRoundedIcon fontSize="small" className="mr-2" />,
				success: <DoneIcon fontSize="small" className="mr-2" /> 
				}}
				Components={{
					error: SnackbarsCustomStyle,
					success: SnackbarsCustomStyle
				}}
			>
				<Wrapper />
			</SnackbarProvider>
		</PageLayer>
	);
};
